import {
  Avatar,
  Button,
  Card,
  CardHeader,
  Fab,
  Grid,
  Hidden,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
} from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Add, MoreVert } from "@material-ui/icons";
import Skeleton from "@material-ui/lab/Skeleton";
import React from "react";
import BaseLayout from "../../components/BaseLayout/BaseLayout";
import { confirm } from "../../components/ConfirmationDialog/ConfirmationDialog";
import InputSearch from "../../components/InputSearch/InputSearch";
import { AntTab, AntTabs } from "../../components/TabPanel/TabPanel";
import tenantStore from "../../Store/TenantStore";
import { submitForm } from "./Container/Form";
import "./Tenant.css";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      width: "100%",
    },
    button: {
      margin: 0,
      maxHeight: 30,
      padding: 1,
    },
    paper: {
      padding: 8,
      width: 290,
    },
    demo1: {
      backgroundColor: theme.palette.background.paper,
      marginBottom: 10,
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(14),
      color: "#FFFFFF",
      textAlign: "center",
      backgroundColor: "#BEBEBE",
      borderRadius: "4px",
    },
    control: {
      padding: theme.spacing(2),
    },
    room: {
      fontSize: "18px",
      fontWeight: 600,
    },
    fab: {
      position: "fixed",
      bottom: theme.spacing(2),
      right: theme.spacing(2),
    },
    card: {
      margin: 5,
      width: "300px",
    },
  })
);

function TenantList(props) {
  const { dataTenant, permissionEditTenant, permissionDeleteTenant } = props;
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  console.log(dataTenant);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <Card className={classes.card}>
      <CardHeader
        avatar={
          dataTenant.logo.square === "" ? (
            <Avatar aria-label="recipe">
              {`${dataTenant.name.trim().split(" ")[0].charAt(0)}`}
            </Avatar>
          ) : (
            <Avatar alt="Remy Sharp" src={`${dataTenant.logo.square}`} />
          )
        }
        action={
          <React.Fragment>
            <IconButton aria-label="settings" onClick={handleClick}>
              <MoreVert />
            </IconButton>
            <Menu
              id="long-menu"
              elevation={0}
              anchorEl={anchorEl}
              getContentAnchorEl={null}
              keepMounted
              open={open}
              onClose={handleClose}
            >
              {permissionEditTenant && (
                <MenuItem onClick={() => props.doEdit(dataTenant)}>
                  Edit
                </MenuItem>
              )}

              {permissionDeleteTenant && (
                <MenuItem onClick={() => props.doDelete(dataTenant)}>
                  Delete
                </MenuItem>
              )}
            </Menu>
          </React.Fragment>
        }
        title={dataTenant.name}
        // subheader={dataTenant.category.name}
      />
    </Card>
  );
}

function Tenant(props) {
  const classes = useStyles();
  const [componentWillmount, setComponentWillMount] = React.useState(false);
  const [search, setSearch] = React.useState("");
  const [tab] = React.useState(0);

  const [tenantState, tenantActions] = tenantStore();

  const handleGetTenant = (refresh) => {
    const header = tenantState.header;
    var query = {
      num: "10",
      cursor: refresh ? "" : header["x-cursor"] || "",
      position: "",
      keyword: search,
    };
    tenantActions.getList(query, refresh);
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  const handleActions = (value) => {
    if (value) {
      submitForm("Update Tenant", value).then(
        (onProcess) => {},
        (onCancel) => {
          setComponentWillMount(!componentWillmount);
        }
      );
    } else {
      submitForm("Create Tenant", null).then(
        (onProcess) => {},
        (onCancel) => {
          setComponentWillMount(!componentWillmount);
        }
      );
    }
  };

  const handleDelete = (value) => {
    confirm("Delete", "Are you sure to Delete ?").then(async (onProcess) => {
      await tenantActions.deleted(value);
      setComponentWillMount(!componentWillmount);
    });
  };

  React.useEffect(() => {
    // Add delay in search
    const timeout = setTimeout(() => {
      handleGetTenant(true);
    }, 500);

    return () => clearTimeout(timeout);
  }, [search, componentWillmount]);

  return (
    <BaseLayout>
      <Grid container className={classes.root}>
        <Grid container style={{ padding: 5, marginBottom: 10 }}>
          <Grid
            container
            item
            xs={10}
            direction="row"
            alignItems="flex-end"
            justify="flex-start"
          >
            <InputSearch
              value={search}
              onChange={(e) => {
                handleSearch(e);
              }}
              placeholder="Search Tenant"
            />
          </Grid>
          <Grid container item xs={2} justify="flex-end" alignItems="flex-end">
            <Hidden xsDown implementation="css">
              {props.params.create && (
                <Tooltip
                  title="add tenant"
                  aria-label="add"
                  arrow
                  placement="bottom"
                >
                  <Fab
                    onClick={() => handleActions(null)}
                    color="secondary"
                    variant="extended"
                    aria-label="add"
                    style={{ marginRight: "10px" }}
                  >
                    <Add /> Add{" "}
                  </Fab>
                </Tooltip>
              )}
            </Hidden>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <div className={classes.demo1}>
            <Grid container>
              <Grid
                container
                item
                xs
                direction="row"
                alignItems="flex-end"
                justify="flex-start"
              >
                <AntTabs
                  style={{ marginTop: "10px" }}
                  value={tab}
                  aria-label="ant example"
                >
                  <AntTab label="Tenant List" />
                </AntTabs>
              </Grid>
            </Grid>
          </div>

          <Grid item xs={12} container justify="center">
            {(tenantState.isLoading
              ? Array.from(new Array(10))
              : tenantState.data
            ).map((value, key) => {
              return (
                <React.Fragment key={key}>
                  {value ? (
                    <TenantList
                      key={key}
                      dataTenant={value}
                      permissionEditTenant={props.params.update}
                      doEdit={() => {
                        handleActions(value);
                      }}
                      permissionDeleteTenant={props.params.delete}
                      doDelete={() => {
                        handleDelete(value);
                      }}
                    />
                  ) : (
                    <Card className={classes.card}>
                      <CardHeader
                        avatar={
                          <Skeleton
                            variant="circle"
                            width="40px"
                            height="40px"
                          />
                        }
                        action={
                          <IconButton aria-label="settings">
                            <MoreVert />
                          </IconButton>
                        }
                        title={<Skeleton width="20%" height="10px" />}
                        subheader={<Skeleton width="5%" height="10px" />}
                      />
                    </Card>
                  )}
                </React.Fragment>
              );
            })}
          </Grid>
          {!tenantState.isLoading && tenantState.data.length === 0 && (
            <Grid item xs={12}>
              <div className={classes.demo1}>
                <Grid
                  item
                  xs
                  container
                  justify="center"
                  style={{ margin: 10, padding: 12 }}
                >
                  <span>No Data</span>
                </Grid>
              </div>
            </Grid>
          )}
          {tenantState.data.length >= 9 && (
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="center"
              style={{ padding: "10px" }}
            >
              {tenantState.lastPage ? (
                <h2>~</h2>
              ) : (
                <Button
                  onClick={() => handleGetTenant(false)}
                  size="small"
                  color="secondary"
                  variant="contained"
                  disabled={tenantState.isLoading}
                >
                  {tenantState.isLoading ? "Please Wait" : "Load More"}
                </Button>
              )}
            </Grid>
          )}
          <Hidden smUp implementation="css">
            {props.params.create && (
              <Tooltip
                title="add tenant"
                aria-label="add"
                arrow
                placement="left"
              >
                <Fab
                  aria-label="Add"
                  classes={{ root: "FabMobile" }}
                  className={classes.fab}
                  color="primary"
                  onClick={() => handleActions(null)}
                >
                  <Add />
                </Fab>
              </Tooltip>
            )}
          </Hidden>
        </Grid>
      </Grid>
    </BaseLayout>
  );
}

export default Tenant;
